import { strToU8, zipSync } from "fflate";
import { buildDatapack } from "../src/domain/datapack";
import { buildFabricMod } from "../src/domain/fabric";
import { buildResourcePack } from "../src/domain/resourcepack";
import type { Entry } from "./library";

const PNG_PREFIX = "data:image/png;base64,";

export interface Downloads {
  fabricJar: Uint8Array;
  datapack: Uint8Array;
  resourcepack: Uint8Array;
}

export function buildZips(entries: Entry[], now = Date.now()): Downloads {
  const datapack = buildDatapack(entries.map((e) => e.creation));
  const resourcepack = buildResourcePack(entries.map((e) => ({ creation: e.creation, texture: e.icon ? dataUrlToBytes(e.icon) : null })));
  const version = `1.0.${Math.floor(now / 1000)}`;
  return {
    fabricJar: zipSync(buildFabricMod(datapack, resourcepack, version)),
    datapack: zipSync(Object.fromEntries(Object.entries(datapack).map(([path, text]) => [path, strToU8(text)]))),
    resourcepack: zipSync(resourcepack),
  };
}

export function dataUrlToBytes(url: string): Uint8Array | null {
  if (!url.startsWith(PNG_PREFIX)) return null;
  const binary = atob(url.slice(PNG_PREFIX.length));
  return Uint8Array.from(binary, (ch) => ch.charCodeAt(0));
}

export function download(name: string, bytes: Uint8Array, type = "application/zip"): void {
  const url = URL.createObjectURL(new Blob([bytes as BlobPart], { type }));
  const link = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
